import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    text: {
      textAlign: "center",
    },
    image: {
      width: 80,
      height: 80,
    },
    card: {
      backgroundColor: theme.input.background,
      padding: constants.divPadding,
      borderRadius: constants.radius.card,
    },
    secondaryText: {
      color: theme.text.secondary,
      marginLeft: spacing.xxl,
    },
    itemTitle: {
      marginLeft: spacing.s,
    },
  };
  return styles;
};
